import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import WebFont from 'webfontloader';
import App from './App';
import reportWebVitals from './reportWebVitals';
import TagManager from 'react-gtm-module';
import config from './config';
import './icons';
import 'normalize.css/normalize.css';
import './styles/global.scss';
const { GTM_ID } = config;
const version = process.env.REACT_APP_VERSION;

let root;

const tagManagerArgs = {
  gtmId: GTM_ID
};

TagManager.initialize(tagManagerArgs);

const component = (
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

// load OTC fonts
WebFont.load({
  google: {
    families: [
      'Nunito Sans:200,200i,400,400i,600,600i,700,700i,800,800i900,900i',
      'Source Serif Pro:400,700'
    ]
  }
});

if (window.location.port === '3004') {
    const rootElement = document.getElementById('market-report-viewport');
    rootElement.setAttribute('data-market-report-ui-version', version);
    root = createRoot(rootElement);
    root.render(component);
}

window.renderMarketReportApp = (containerId) => {
    const rootElement = document.getElementById(containerId);
    if (!rootElement) return;

    rootElement.setAttribute('data-market-report-ui-version', version);
    root = createRoot(rootElement);
    root.render(component);
};

window.unmountMarketReportApp = () => {
    root.unmount();
};

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
